// components/PropertyCategories.jsx
import React, { useContext } from "react";
import {
  FaBuilding,
  FaHome,
  FaCity,
  FaUmbrellaBeach,
  FaCrown,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IMAGES_BASE_URL } from "../../api/config";
import { useTranslateKey } from "../translation/useTranslateKey";
import { LangContext } from "../translation/langugeContext";

const PropertyCategories = ({ luxury_properties }) => {
  const navigate = useNavigate();
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);

  const iconMap = {
  FaBuilding: <FaBuilding className="text-[#F9C835] mr-2" />,
  FaHome: <FaHome className="text-[#F9C835] mr-2" />,
  FaCity: <FaCity className="text-[#F9C835] mr-2" />,
  FaUmbrellaBeach: <FaUmbrellaBeach className="text-[#F9C835] mr-2" />,
  // add more icons here if needed
  };

  const handleClick = (propertyType) => {
    navigate(`/property-browser?new_property_type=${propertyType}&filter_type=luxury`);
  };

  return (
    <section
      id="luxury-properties"
      className="pb-24 bg-gradient-to-b from-[#121525]/95 to-[#121525] relative"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="text-3xl font-bold mb-4 flex justify-center">
            <FaCrown style={{ color: "#F9C835" }} />
            <h2>
              {t("luxuryTitle1")}{" "}
              <span style={{ color: "#F9C835" }}>{t("luxuryTitle2")}</span>
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 mb-24">
          {luxury_properties.map((property) => (
            <div
              key={property.id}
              className="category-card relative overflow-hidden rounded-xl group cursor-pointer h-[300px] lg:col-span-3 "
            >
              <button
                type="button"
                onClick={() => handleClick(property.property_type)}
                className="absolute inset-0 z-30 w-full h-full cursor-pointer"
                aria-label={`${t("browse")} ${lang === "ar" ? property.property_type_name_ar : property.property_type_name}`}
                style={{ background: "none", border: "none", padding: 0 }}
              ></button>

              <img
                src={`${IMAGES_BASE_URL}${property.image}`}
                alt={lang === "ar" ? property.property_type_name_ar : property.property_type_name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />

              <div className="absolute bottom-0 left-0 right-0 p-4 z-10 bg-black/50 text-white md:p-8">
                <h3 className="text-xl md:text-3xl font-bold mb-2 flex items-center gap-2">
                  {iconMap[property.icon_name] || <FaHome className="text-[#F9C835] mr-2" />}
                  {lang === "ar"
                    ? property.property_type_name_ar
                    : property.property_type_name.charAt(0).toUpperCase() + property.property_type_name.slice(1) + "s"}
                </h3>
                <p className="text-[#F9C835] text-base md:text-lg font-semibold mb-1">
                  {property.luxury_count
                    ? property.luxury_count + " " + t("units")
                    : 15+ " " + t("units")}
                </p>
                <p className="text-sm md:text-base text-gray-200">
                  {lang === "ar" ? property.description_ar : property.description_en}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyCategories;
